export enum OwnershipSource {
  Public = 'public',
  Surveillance = 'surveillance'
}
